<template>
    <div class="sty-section  grid grid__base" :class="bemFacets">
        <div class="sty-section--data-bridge" ref="data-bridge"/>

        <div class="grid--container">
            <sty-header :facets="['section-title']">
                <h2 class="u-reset u-reset__sty" :id="anchor" v-text="sectionTitle"/>
            </sty-header>
        </div>

        <div class="grid--container">
            <div class="grid--row sty-section--domains">
                <div class="grid--col sty-section--domain"
                        :class="['sty-section--domain__' + colorMapName]"
                        v-for="(colorMapData, colorMapName) in bridgeData"
                        :key="colorMapName">
                    <sty-header>
                        <h3 class="u-reset u-reset__sty sty-section--domain-title" v-text="colorMapName"/>
                    </sty-header>

                    <div class="grid--row sty-section--color-entries">
                        <div class="grid--col sty-section--color-entry"
                                v-for="(colorData, colorName) in colorMapData"
                                :key="colorName">
                            <div class="sty-section--color-swatch">
                                <div class="sty-section--color-swatch-bg">
                                    <div class="sty-section--color-swatch-bg-variant sty-section--color-swatch-bg-variant__lighter"/>
                                    <div class="sty-section--color-swatch-bg-variant sty-section--color-swatch-bg-variant__darker"/>
                                </div>
                                <div class="sty-section--color-swatch-docu">
                                    <h4 class="u-reset sty-section--color-swatch-name"/>
                                    <span class="sty-section--color-swatch-definition"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StyHeader from 'framework/styleguide/header';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';


    export default {
        components: {
            StyHeader,
        },
        mixins: [
            bemMixin('sty-section'),
        ],
        props: {
            anchor: {
                type: String,
                required: true,
            },
            sectionTitle: {
                type: String,
                required: true,
            },
            bridgeData: {
                type: Object,
                required: true,
            },
        },
    };
</script>
